/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DashboardTestNewsletter } from 'cio/utils/metrics/models/dashboard-tests';
import moment from 'moment-timezone';
import { SortDirection } from 'cio/utils/sort';

interface DashboardPageTestsCardNewslettersRowArgs {
  newsletter: DashboardTestNewsletter;
  sortByItem: {
    label: string;
    value: string;
    sortBy: string;
    sortByDirection: SortDirection;
  };
  trackNavigate: (destination: string) => unknown;
}

export default class DashboardPageTestsNewslettersRowCard extends Component<DashboardPageTestsCardNewslettersRowArgs> {
  get timeAgo() {
    let timeAgoUnit: 'day' | 'hour' = 'day';
    let timeAgo = moment().diff(moment.unix(this.args.newsletter.sentAt), timeAgoUnit);

    // if the test started "0 days" ago, calculate the diff in hours instead
    if (timeAgo === 0) {
      timeAgoUnit = 'hour';
      timeAgo = moment().diff(moment.unix(this.args.newsletter.sentAt), timeAgoUnit);
    }

    return {
      value: timeAgo,
      unit: timeAgoUnit,
    };
  }
}
